import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import React from 'react';
import './TimelineDependencyChips.scss';

interface TimelineDependencyChipsProps {
    index: number;
    eventIndex: number;
    eventName: string;
    offsetDays: number;
    isRemovable: boolean;
    onRemoveButtonClick?(): void;
    isEditMode: boolean;
    onOffsetDaysChange?: (newOffset: number) => void;
}

const TimelineDependencyChips = (props: TimelineDependencyChipsProps) => {
    const {
        index,
        eventIndex,
        eventName,
        offsetDays,
        isRemovable,
        isEditMode,
    } = props;

    return (
        <div key={index} className="timeline-dependency-chips">
            <span
                className={`text-bold event-label ${
                    props.isEditMode ? 'edit-mode' : 'view-mode'
                }`}>
                {`${eventIndex + 1}.`}
                <span className="event-name-label" title={eventName}>
                    {eventName || 'Unknown'}
                </span>
            </span>
            {isEditMode && isRemovable ? (
                <TextField
                    type="number"
                    className="input-border offset-input"
                    value={offsetDays}
                    onChange={(e) => {
                        const value = Number(e.target.value);
                        if (!isNaN(value) && props.onOffsetDaysChange) {
                            props.onOffsetDaysChange(value);
                        }
                    }}
                    disabled={!props.isRemovable}
                    size="small"
                    sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                    }}
                />
            ) : (
                <></>
            )}
            <div>
                <span className="offset-lable">
                    <span>{`${
                        !isEditMode || !isRemovable ? offsetDays : ''
                    } days`}</span>
                    {isRemovable ? (
                        <FontAwesomeIcon
                            title="Remove dependency"
                            icon={faTimes}
                            className="cursor-pointer"
                            style={{
                                marginLeft: '6px',
                            }}
                            size="lg"
                            onClick={() => {
                                props.onRemoveButtonClick();
                            }}
                        />
                    ) : (
                        []
                    )}
                </span>
            </div>
        </div>
    );
};

export default TimelineDependencyChips;
